import { createSlice } from "@reduxjs/toolkit";

const now = new Date();
const today1 = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}T00:00`;
const today2 = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}T23:59`;

const d = {
    isCod: null,
    subAccountId: '',
    locationId: '',
    from: today1,
    to: today2,
    isWithoutShipper: false
};

const AddressLabelSlice = createSlice({
    name: 'addressLabelData',
    initialState: {
        data: d,
        locations: [],
        grid: [],
        type: 1,
        isTwoCnRow: false
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload.data
        },
        reset: (state, action) => {
            state.data = d
        },
        setType: (state, action) => {
            state.type = action.payload.data
        },
        setTwoCnRow: (state, action) => {
            state.isTwoCnRow = action.payload.data
        },
        setLocations: (state, action) => {
            state.locations = action.payload.data
        },
        setGrid: (state, action) => {
            state.grid = action.payload.data
        },
        updateGrid: (state, action) => {
            const index = action.payload.index;
            const key = action.payload.key;
            const val = action.payload.val;
            state.grid[index][key] = val;
        },
        updateGridObject: (state, action) => {
            const index = action.payload.index;
            const data = action.payload.data;
            state.grid[index] = data;
        }
    }
});

export default AddressLabelSlice.reducer;
export const { setData, reset, setType, setLocations, setGrid, updateGrid, updateGridObject, setTwoCnRow } = AddressLabelSlice.actions;